export class Bando {
  id;
  nome;
  link;
  descrizione;
  annoEducativo;

  fasi;
  // adesioni;
}
